import PaidCardShippingDetailsForm from "./CompanyCardShippingDetails";

export default PaidCardShippingDetailsForm;
export type { CompanyCardShippingDetailsFormType } from "./components/CompanyCardShippingDetailsForm/validationSchema";
export { CompanyCardShippingDetailsFormValidationSchema } from "./components/CompanyCardShippingDetailsForm/validationSchema";
export { useCompanyCardShippingDetails } from "./useCompanyCardShippingDetails";
